/* eslint-disable react/no-find-dom-node */
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

interface AutoScrollProps {
    children: React.ReactNode;
    startAtBottom?: boolean;
}

class AutoScroll extends Component<AutoScrollProps> {
    node!: HTMLElement;

    static defaultProps = {
        startAtBottom: false
    };

    componentDidMount() {
        this.node = findDOMNode(this) as HTMLElement;
        if (this.props.startAtBottom) {
            this.node.scrollTop = this.node.scrollHeight;
        }
    }

    getSnapshotBeforeUpdate() {
        const { scrollHeight, clientHeight, scrollTop } = this.node;

        return clientHeight + scrollTop >= 0.9 * scrollHeight;
    }

    componentDidUpdate(_props: Readonly<AutoScrollProps>, _state: never, shouldScroll: boolean) {
        if (shouldScroll) {
            this.node.scrollTop = this.node.scrollHeight;
        }
    }

    render() {
        return React.Children.only(this.props.children);
    }
}

export default AutoScroll;
